module.exports = __webpack_public_path__ + "img/header_1.32145988.png";